/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import React from "react";
import { HelmetProvider } from "react-helmet-async";

export const wrapRootElement = ({ element }) => (
  <HelmetProvider>{element}</HelmetProvider>
);
